export const PAGE = {
  ALL: "",
  SPORT_SELECTION_PAGE: "sport-selection-page",
  HOMEPAGE: "home",
  USER_REGIONS: "user-regions",
  USER_SEARCH: "user-search",
  LIST_COLLECTIONS_GOALS: "list-collections-goals",
  USER_PROFILE: "user-profile",
};

export const pageLabels = {
  [PAGE.ALL]: "All",
  [PAGE.SPORT_SELECTION_PAGE]: "Sport Selection Page",
  [PAGE.HOMEPAGE]: "Homepage",
  [PAGE.USER_REGIONS]: "User Regions",
  [PAGE.USER_SEARCH]: "User Search",
  [PAGE.LIST_COLLECTIONS_GOALS]: "List Collections Goals",
  [PAGE.USER_PROFILE]: "User Profile",
};

export const pageBackgroundFormOptions = [
  { value: PAGE.SPORT_SELECTION_PAGE, label: pageLabels[PAGE.SPORT_SELECTION_PAGE] },
  { value: PAGE.HOMEPAGE, label: pageLabels[PAGE.HOMEPAGE] },
  { value: PAGE.USER_REGIONS, label: pageLabels[PAGE.USER_REGIONS] },
  { value: PAGE.USER_SEARCH, label: pageLabels[PAGE.USER_SEARCH] },
  { value: PAGE.LIST_COLLECTIONS_GOALS, label: pageLabels[PAGE.LIST_COLLECTIONS_GOALS] },
  { value: PAGE.USER_PROFILE, label: pageLabels[PAGE.USER_PROFILE] },
];

export const pageFilters = [
  // 
];
